import React from "react";

// Primitive form condivise: centralizzano lo stile dei campi (prima ripetuto
// come "border border-gray-300 px-2 py-1 rounded" in decine di punti) e il
// pattern label-sopra-campo (<label className="block">…</label>).

// Stile base di input/select. Le varianti `disabled:` sono innocue sui campi
// abilitati e tornano utili quando un campo è disabilitato.
export const FIELD_CLASS =
  "w-full border border-gray-300 px-2 py-1 rounded disabled:bg-gray-100 disabled:text-gray-400";

interface FormLabelProps {
  label: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}

// Label con il campo come children (testo sopra, controllo sotto).
export const FormLabel: React.FC<FormLabelProps> = ({ label, className = "block", children }) => (
  <label className={className}>
    {label}
    {children}
  </label>
);

type TextFieldProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label: React.ReactNode;
  // Classe del <label> contenitore (default "block").
  labelClassName?: string;
};

export const TextField: React.FC<TextFieldProps> = ({ label, labelClassName, className, ...inputProps }) => (
  <FormLabel label={label} className={labelClassName}>
    <input className={`${FIELD_CLASS} ${className ?? ""}`.trim()} {...inputProps} />
  </FormLabel>
);

type SelectFieldProps = React.SelectHTMLAttributes<HTMLSelectElement> & {
  label: React.ReactNode;
  labelClassName?: string;
};

export const SelectField: React.FC<SelectFieldProps> = ({
  label,
  labelClassName,
  className,
  children,
  ...selectProps
}) => (
  <FormLabel label={label} className={labelClassName}>
    <select className={`${FIELD_CLASS} ${className ?? ""}`.trim()} {...selectProps}>
      {children}
    </select>
  </FormLabel>
);
